import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
:root,
:host {
  --size-base-unit: 0.5rem;
}

/**
 * RTL support for values logical properties can't automatically adjust for
 * 1) Percentage based horizontal translate values need to be flipped
 * 2) Background gradients using "to right" or "to left" need to be switched to using deg values
 * 3) Background Position From is used for reversing animation from right to left at 0%
 * 4) Background Position To is used for reversing animation from right to left at 100%
 * 5) Rotate Icon to 180deg for nav button
 * 6) Transformation size for badge left positions
 * 7) Transformation size for badge right positions
 * 8 to 18) Padding values for Input Field Type Tel
 */
[dir=rtl] {
  --rtlTranslateX: 50%; /* 1 */
  --rtlGradientToRight: 270deg; /* 2 */
  --rtlBackgroundPositionFrom: -135%; /* 3 */
  --rtlBackgroundPositionTo: 0%; /* 4 */
  --rtlRotate180: 180deg; /* 5 */
  --rtlRotate135: 135deg;
  --rtlBadgeLeft: -1.5; /* 6 */
  --rtlBadgeRight: 1.5; /* 7 */
  --rtlTelTypeInputFieldPaddingStart: calc(var(--size-base-unit) * 5); /* 8 */
  --rtlTelTypeInputFieldPaddingEnd: calc(var(--size-base-unit) * 2); /* 9 */
  --rtlTelTypeInputFieldMedPaddingStart: calc(var(--size-base-unit) * 4.5); /* 10 */
  --rtlTelTypeInputFieldMedPaddingEnd: calc(var(--size-base-unit) * 1.5); /* 11 */
  --rtlTelTypeInputFieldSmPaddingStart: calc(var(--size-base-unit) * 4); /* 12 */
  --rtlTelTypeInputFieldSmPaddingEnd: calc(var(--size-base-unit) * 1); /* 13 */
  --rtlTelTypeInputFieldCharBeforePaddingEnd: calc(var(--size-base-unit) * 3.75); /* 14 */
  --rtlTelTypeInputFieldCharAfterPaddingStart: calc(var(--size-base-unit) * 6); /* 15 */
  --rtlTelTypeInputFieldCharAfterErrPaddingStart: calc(var(--size-base-unit) * 9); /* 16 */
  --rtlTelTypeInputFieldIconAfterErrPaddingStart: calc(var(--size-base-unit) * 8); /* 17 */
  --rtlTelTypeInputFieldIconCharAfterErrPaddingStart: calc(var(--size-base-unit) * 12); /* 18 */
  --rtlDisplayNone: none;
  --rtlDisplayBlock: block;
  --rtlDrawerRightTranslateX: -100%;
  --rtlDrawerLeftTranslateX: 100%;
}

/**
 * Visible focus outline for elements on a light background
 */
/**
 * Visible focus outline for elements on a dark background
 */
/**
 * Invisible focus outline for elements that need a more visible
 * focus state for high-contrast mode
 */
/**
 * Visually hidden from display
 */
/**
 * style for text ellipsis
 */
/**
 * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
 */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */ /* ------------------------------------*\
  #SKELETON
\*------------------------------------ */
/**
 * 1) Bar used to represent loading content when the data isn't pulled in yet
 */
.cat-c-skeleton {
  position: relative;
  padding: var(--cat-skeleton-loader-height, calc(var(--size-base-unit) * 2));
  width: var(--cat-skeleton-loader-width, 100%);
  background: linear-gradient(-90deg, #f6f6f6 0%, #e1e1e1 50%, #f6f6f6 100%);
  background-size: 400% 400%;
  animation: pulse 1.25s linear infinite;
}
.cat-c-skeleton .cat-c-skeleton__loader-text {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

/**
 * Small skeleton
 */
.cat-c-skeleton--sm {
  padding: calc(var(--size-base-unit) * 1);
}

/**
 * Large skeleton
 */
.cat-c-skeleton--lg {
  padding: calc(var(--size-base-unit) * 4) calc(var(--size-base-unit) * 2);
}

/**
 * Extra large skeleton
 */
.cat-c-skeleton--xl {
  padding: calc(var(--size-base-unit) * 12) calc(var(--size-base-unit) * 2);
}

/**
 * Extra extra large skeleton
 */
.cat-c-skeleton--xxl {
  padding: calc(var(--size-base-unit) * 24) calc(var(--size-base-unit) * 2);
}

/**
 * Pulsing animation for loading look
 */
@keyframes pulse {
  0% {
    background-position: var(--rtlBackgroundPositionFrom, 0%) 0%;
  }
  100% {
    background-position: var(--rtlBackgroundPositionTo, -135%) 0%;
  }
}
`;
       